// extracted by mini-css-extract-plugin
module.exports = {"about":"SingleAbout_about__32cnY","about-img":"SingleAbout_about-img__1ieE6"};